import React, { useState, useEffect } from 'react';
import { 
         Grid,
         LinearProgress,
         Paper,
         TextField,
        } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { 
    LoadingOutlined as LoadingOutlinedIcon,
    SaveOutlined as SaveOutlinedIcon,
   } from '@ant-design/icons';
import {     MonetizationOn as MonetizationOnIcon, } from '@material-ui/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { 
    Button as ButtonAntd,
    Popconfirm,
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';
const arrMeses = ['','Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

function DISCOUNT_ADD(){
    const { authTokens, ageWork, setRuta, setOpen } = useAuth(); 
    const { enqueueSnackbar} = useSnackbar()
    const [ getDatos, setDatos] = useState({
        Status:'',
        Nombres:'',
        CI:'',
        Celular:'',
        Correo:'',
        Direccion:'',
        idServicio:'',
        numDescuento:0,
        Observacion:'',
        Zona:'',
        MesServicio:'',
        Valor:0,
        AnioServicio:0,
    });
    const [ dataZona, setDataZona ] = useState([]);
    const [ getClientes, setClientes ] = useState([]);
    const [ isSavingOt, setSavingOt ] = useState(false);
    const [ getServicios, setServicios ] = useState([]);
    const [ isByNombres, setByNombres ] =  useState(true);
    const [ isReadyZones, setReadyZones ] = useState(false);
    const [ getMeses, setMeses ] = useState([]);
    

    useEffect(
        ()=>{  
            (async ()=>{
                setOpen(false);
                const PeticionZona = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
                const resultZona = await PeticionZona.json();
                setRuta('/Descuentos/Crear');
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZona.map(el=>el.Zona));
                }else{
                    setDataZona(authTokens.Zonas.map(el=>el.Zona)); 
                }
                setReadyZones(true);
                const elMes = new Date().getMonth() + 1;
                setMeses(()=> arrMeses.filter((el,index)=> index >= elMes));
            })();
            
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );

    const handleSelectZona = (valZ)=>{
        fetch('/api/clientes/byEmpresa&Zona',
            { 
                method:'POST', 
                body: JSON.stringify({Empresa:authTokens.Empresa, Zona:valZ}), 
                headers:{'Content-Type': 'application/json'}
            }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.Status){
                enqueueSnackbar(result.Status, {variant:'error'})
            }else{
                const resultClientes = result.filter(value=>value.Status === 'Activo');
                const arrClientes = [];
                for(const x in resultClientes){
                    const objeto = {...resultClientes[x]};
                    const arrFiltrado = resultClientes[x].Servicios.filter(value=>value.ZonaService === valZ);
                    if(arrFiltrado.length > 0){
                        objeto.Servicios = arrFiltrado;
                        arrClientes.push(objeto);
                    }
                }    
                setClientes(arrClientes);
                setDatos({...getDatos, Zona:valZ});
            }
        });
    };

    const handleClearZona = ()=>{
        setDatos({
            Nombres:'',
            CI:'',
            Celular:'',
            Correo:'',
            Direccion:'',
            idServicio:'',
            numDescuento:0,
            Observacion:'',
            MesServicio:'',
            TipoServicio:'',
            Valor:0,
            Zona:'',
            AnioServicio:0,
        });   
        setServicios([]);
        setClientes([]);
        setByNombres(true);
    };

    const handleSelectName = (e, value, reason)=>{
        if(reason === 'select-option'){
            if(isByNombres){
                const arrFil = getClientes.filter(value2=>value2.Nombres.toString() === value.toString())[0];
                setDatos({...getDatos, 
                    Nombres:value,
                    CI:arrFil.CI,
                    Celular:arrFil.Celular.map(el=>el.celular)[0],
                    Correo:arrFil.Correo.map(el=>el.correo)[0],
                    Direccion:'',
                    idServicio:'',
                    MesServicio:'',
                    TipoServicio:'',
                    }); 
                setServicios(arrFil.Servicios);
            }else{
                const arrFil = getClientes.filter(value2=>value2.CI.toString() === value.toString())[0];
                setDatos({...getDatos, 
                    Nombres:arrFil.Nombres,
                    CI:value,
                    Celular:arrFil.Celular.map(el=>el.celular)[0],
                    Correo:arrFil.Correo.map(el=>el.correo)[0],
                    Direccion:'',
                    idServicio:'',
                    MesServicio:'',
                    TipoServicio:'',
                    }); 
                setServicios(arrFil.Servicios);
            }  
        }else{
            setDatos({...getDatos, 
            Nombres:'',
            CI:'',
            Celular:'',
            Correo:'',
            Direccion:'',
            idServicio:'',
            MesServicio:'',
            TipoServicio:'',
            });   
            setServicios([]);
        }
             

    };

    const handleSelectServicio = (e, value, reason)=>{
        if(reason === 'select-option'){
            const arrFil = getServicios.filter(value2=>value2.Direccion.toString() === value.toString())[0];
            setDatos({...getDatos, 
                Direccion:value,
                idServicio:arrFil._id,
                TipoServicio: arrFil.TipoPagoBoolean ? 'PrePago':'PostPago'
            });
        }else{
            setDatos({...getDatos, 
                Direccion:'',
                MesServicio:'',
                TipoServicio:'',
                idServicio:''});   
        }    
    };

    const handleSelectMesServicio = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatos({...getDatos, MesServicio:value});
        }else{
            setDatos({...getDatos, Mes:''});   
        }    
    };

    const handleDatos = ({target}) =>{ setDatos({...getDatos, [target.id]: target.value}) };

    const handleByNombres = (checked)=>{ setByNombres(checked); };

    const handleCreate = ()=>{
        setSavingOt(true);
        const infoDescuentos = {...getDatos};
        infoDescuentos.Status = 'Pendiente';
        infoDescuentos.Empresa = authTokens.Empresa;
        infoDescuentos.AnioServicio = ageWork;
        fetch('/api/Descuentos',{
            method:'POST',
            body: JSON.stringify(infoDescuentos),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setSavingOt(false);
            if(result._id){
                Swal.fire({
                    title:`SE HA CREADO EL DESCUENTO N° ${result.numDescuento}`,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    width:600,
                    confirmButtonText:'OK',
                }).then((result)=>{
                    if(result.isConfirmed){
                        handleClearZona();
                    }
                })

            }else if(result.message){ 
                Swal.fire({
                    title:result.message,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    width:600,
                    confirmButtonText:'OK',
                });
            }else{
                enqueueSnackbar(result.status, {variant:'error'}); 
            } 
        });
    };

    return(
        <Grid container spacing={2} justifyContent='center' style={{padding:10, height:'90vh',overflowY:'auto', width:'100%', border:'1px solid #D0D3D4', borderRadius:5}}>
            <Grid item  lg={5} md={6} sm={10} xs={12}>
                <Paper elevation={3} style={{padding:15, width:'100%'}}>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item xs={12} style={{height:5}}>
                            {isSavingOt &&  <LinearProgress color='secondary' /> }
                        </Grid>
                        <Grid item md={8} xs={12}>
                            <Autocomplete
                                id="Zona"
                                options={dataZona}
                                value={getDatos.Zona || ''}                              
                                renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={(e,value, reason)=>{
                                    if(reason ===  'clear'){
                                        handleClearZona()
                                    }else{
                                        handleSelectZona(value);
                                    }
                                }}  
                                disabled={!isReadyZones}
                            />
                        </Grid>     
                        <Grid item md={4} xs={12}>
                            <TextField 
                                id='Valor'
                                fullWidth
                                label='Valor'
                                value={getDatos.Valor || ''}
                                onChange={handleDatos}  
                                variant='outlined'
                                size='small'
                                type='number'
                                InputProps={{
                                    startAdornment: <MonetizationOnIcon color='primary'/>,
                                }}
                                //disabled={!isSelectedZona}
                            />
                        </Grid>                    
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-between' spacing={1}>
                                <Grid item xs={10}>
                                    <Autocomplete
                                        id="Cliente"
                                        options={getClientes.map(value=> isByNombres ? value.Nombres : value.CI)}
                                        value={ isByNombres ? getDatos.Nombres : getDatos.CI || ''}                              
                                        renderInput={(params) => <TextField {...params} label="Cliente" variant="outlined" size='small' fullWidth color='primary'/>}
                                        onChange={handleSelectName}  
                                    />
                                </Grid>
                                <Grid item  style={{paddingTop:15}}>
                                    <TooltipAntd title="CI O NOMBRES" color='BLUE' >
                                        <SwitchAntd checkedChildren="ON" unCheckedChildren="OFF" checked={isByNombres} onChange={handleByNombres} />
                                    </TooltipAntd>  
                                </Grid>
                            </Grid> 
                        </Grid>         
                        <Grid item  xs={12}>
                            <Autocomplete
                                id="Servicio"
                                options={getServicios.map(value=>value.Direccion)}
                                value={getDatos.Direccion || ''}                              
                                renderInput={(params) => <TextField {...params} label="Servicio" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectServicio}  
                            />
                        </Grid>
                        <Grid item  md={6} xs={12}>
                            <TextField 
                                id='TipoServicio'
                                fullWidth
                                label='Tipo Servicio'
                                value={getDatos.TipoServicio || ''}
                                variant='outlined'
                                size='small'
                                
                            />     
                        </Grid>
                        <Grid item  md={6} xs={12}>
                            <Autocomplete
                                id="Mes"
                                options={getMeses}
                                value={getDatos.MesServicio || ''}                              
                                renderInput={(params) => <TextField {...params} label="Mes" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectMesServicio}  
                            />
                        </Grid>
                        <Grid item xs={12} > 
                            <TextField 
                                id='Detalle'
                                fullWidth
                                label='Detalle'
                                value={getDatos.Detalle || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                                multiline
                            />                     
                        </Grid>
                        <Grid item xs={12} > 
                            <TextField 
                                id='Observacion'
                                fullWidth
                                label='Observacion'
                                value={getDatos.Observacion || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                                multiline
                            />                     
                        </Grid>
                        <Grid item xs={6}>
                            <ButtonAntd block type="danger"  size='large'  onClick={handleClearZona}>
                                RESETEAR
                            </ButtonAntd>     
                        </Grid>
                        <Grid item xs={6}>            
                            <Popconfirm
                                title="DESEA CREAR ESTE DESCUENTO?"
                                onConfirm={handleCreate}
                                okText="SI"
                                cancelText="NO"
                            >
                                <ButtonAntd block type="primary"  size='large' icon={isSavingOt ? <LoadingOutlinedIcon/> :<SaveOutlinedIcon/>} >
                                    GUARDAR
                                </ButtonAntd>
                            </Popconfirm>
                        </Grid> 
                    </Grid>   
                </Paper>
            </Grid>
            
        </Grid>
    );
};

function ADD_DISCOUNT(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <DISCOUNT_ADD />
        </SnackbarProvider>
    );
};

export default ADD_DISCOUNT;